import { useState } from 'react';
import './CommercialBenefits.css';
import commercialBg from '../../assets/commercial_battery_storage.png';

const benefits = [
  {
    title: 'Reduce Energy Costs',
    desc: 'Store energy when costs are lower and use it when prices are higher.',
  },
  {
    title: 'Peak Demand Management',
    desc: 'Reduce demand charges during high-consumption periods.',
  },
  {
    title: 'Improve Energy Resilience',
    desc: 'Maintain critical operations during power interruptions or outages.',
  },
  {
    title: 'Maximise Solar Self-Consumption',
    desc: 'Use more of the energy you generate on-site and rely less on the grid.',
  },
  {
    title: 'Future-Proof Your Business',
    desc: 'Prepare for changing energy markets and evolving regulations.',
  },
  {
    title: 'Scalable Solutions',
    desc: 'Systems designed to grow and adapt alongside your business needs.',
  },
];

export default function CommercialBenefits() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="cbene-section">
      <div className="cbene-inner">

        {/* Left dark card */}
        <div className="cbene-left">
          <div className="cbene-left-content">
            <p className="cbene-tag">BENEFITS</p>
            <h2 className="cbene-title">
              Why Battery Storage Makes Business Sense
            </h2>
            <div className="cbene-underline" />
            <p className="cbene-desc">
              Smart energy storage solutions designed to reduce costs, improve resilience, and future-proof your business.
            </p>
          </div>
          <div className="cbene-img-wrap">
            <img src={commercialBg} alt="Commercial battery storage" className="cbene-img" />
          </div>
        </div>

        {/* Right accordion */}
        <div className="cbene-right">
          {benefits.map((b, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className={`cbene-item${isOpen ? ' cbene-item--open' : ''}`}>
                <button className="cbene-item-header" onClick={() => toggle(i)}>
                  <span className="cbene-item-num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="cbene-item-title">{b.title}</span>
                  <span className="cbene-toggle">{isOpen ? '−' : '+'}</span>
                </button>
                <div className="cbene-item-body">
                  <p className="cbene-item-desc">{b.desc}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
